<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div
          :class="{'modal-container--large' : large}"
          class="modal-container"
        >
          <a
            v-if="exit"
            href="#"
            class="close"
            @click.stop.prevent="closeModal"
          />
          <div class="modal__header">
            <slot name="header" />
          </div>
          <div class="modal__text">
            <slot />
          </div>
          <div class="modal__footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
// import faqData from "@/faq.json";
import { mapState } from "vuex";

export default {
  name: "Modal",
  props: {
    large: {
      type: Boolean,
      required: false,
      default: false
    },
    exit: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    ...mapState({
      stateModal: state => state.openModal
    })
  },
  methods: {
    closeModal() {
      this.$store.dispatch("toggleModal", !this.stateModal);
    }
  }
};
</script>
<style scoped>

/* Standaard styling voor de footer */
.modal__header {
  flex: 1; /* Dit zorgt ervoor dat de inhoud de beschikbare ruimte opvult */
}
.modal__text {
  flex: 1; /* Dit zorgt ervoor dat de inhoud de beschikbare ruimte opvult */
}
.modal__footer {
  background-color:  rgba(245, 166, 35, 1);
  padding: 20px 40px;
  position: sticky;
  bottom: 0;
  width: 100%;
}

:root {
  --modal-height: 50vh;
}

.modal {
  background-color: rgba(255, 255, 255, 1);
  padding: 20px;
  width: 50vw;
  height: var(--modal-height);
  margin: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: all 0.3s ease;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column; /* Stelt in dat we de modalinhoud en de tekst onderaan willen hebben */
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  background-color: rgba(255, 255, 255, 1);
  padding: 60px 40px;
  width: 100vw;
  height: 100vh;
  margin: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: all 0.3s ease;
  overflow: auto;
  display: flex;
  flex-direction: column; /* Zorg ervoor dat de kinderen onder elkaar staan */
  height: 100%; /* De wrapper moet de volledige hoogte van het scherm vullen */
}

.modal-container--large {
  padding: 20px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.close {
  position: absolute;
  right: 10px;
  top: 60px;
  width: 32px;
  height: 32px;
  opacity: 0.5;
  z-index: 20;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: " ";
  height: 15px;
  width: 2px;
  background-color: #000;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}

@media (min-width: 768px) {
  .modal-container {
    border-radius: 6px;
    width: 50vw;
    height: 50vh;
  }
  .modal-container--large {
    width: 80vw;
    height: 90vh;
    padding: 0;
  }
}

@media (min-width: 1441px) {
  .modal-container--large {
    width: 50vw;
    height: 90vh;
    padding: 0;
  }
}
</style>
